module.exports = __webpack_public_path__ + "img/ca_amex.4fcb4f84.png";